import React from "react";
import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./Context/authContext";

import Profile from "./Pages/Profile";
import Home from "./Pages/Home";
import NotFound from "./Pages/NotFound";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="profile" element={<Profile />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthProvider>
    </div>
  );
}
export default App;
